<div class="container mt-5 mb-5">
  <span *ngIf="desktopViewVisible else mobileSubscriptionTable">
    <app-subscription-table-desktop
     id="subscription-table"
     [identibasePlusButtonLabel]="'Learn more'"
     [identialertButtonLabel]="'Learn more'"
     [identifindButtonLabel]="'Learn more'"
     (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-desktop>
  </span>
  <ng-template #mobileSubscriptionTable>
    <app-subscription-table-mobile
     id="subscription-table"
     [identibasePlusButtonLabel]="'Learn more'"
     [identialertButtonLabel]="'Buy now'"
     [identifindButtonLabel]="'Learn more'"
     (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-mobile>
  </ng-template>
</div>
